import React from 'react';
import { castArray, compact, isArray } from 'lodash';
import { useMutation } from 'react-query';

import { postCreaditCardRequest } from 'queries';
import { parseErrors, Toast } from 'helpers';
import { JsonDataItem } from 'types';

export const useRequestCreditCard = (customer: JsonDataItem | null) => {
  const email = customer?.email;
  const primaryMobile = customer?.contact1.contact1_mobile?.trim();
  const secondaryMobile = customer?.contact2.contact2_mobile.trim();

  const initialValues = {
    emailNotification: compact([email]),
    smsNotification: compact([primaryMobile]),
  };

  const emailOptions = compact([
    email && {
      label: <>Primary Contact - {email}</>,
      value: email,
    },
  ]);

  const smsOptions = compact([
    primaryMobile && {
      label: <>Primary Contact - {primaryMobile}</>,
      value: primaryMobile,
    },
    secondaryMobile && {
      label: <>Secondary Contact - {secondaryMobile}</>,
      value: secondaryMobile,
    },
  ]);

  const {
    mutate,
    isLoading: isRequestSending,
    isSuccess: isRequestSent,
  } = useMutation(postCreaditCardRequest, {
    onSuccess: () => Toast.show({ description: 'Request has been sent to the customer.', type: Toast.Type.Success }),
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  const requestCreditCard = (data: JsonDataItem | null) => {
    data &&
      mutate({
        customerId: customer?.ID,
        emailNotification: isArray(data.emailNotification) ? data.emailNotification[0] : data.emailNotification,
        smsNotification: castArray(data.smsNotification),
      });
  };

  return {
    requestCreditCard,
    isRequestSending,
    isRequestSent,
    initialValues,
    emailOptions,
    smsOptions,
  };
};
